// Artifact kinds. A skill is a folder (SKILL.md + helper files); every other kind is a single
// .md that drops into a specific place. The new kinds are upload-only (no AI builder yet) — the
// credit economy is kind-blind, so surfacing them is just labels + a download hint.
//
// single:  true = one .md, no helper files.
// badge:   marketplace/detail chip label (null = skill, no chip).
// mainLabel/placeholder: the "main file" field on the upload form.
// lands:   where the downloaded file goes, shown on the detail page.
export const KINDS = {
  skill: {
    label: "Skill", plural: "Skills", single: false, badge: null,
    mainLabel: "SKILL.md",
    lands: null,
    placeholder: "---\nname: my-skill\ndescription: What it does. Use when ...\n---\n# My Skill\n1. Step one\n2. Step two",
  },
  agent: {
    label: "Agent", plural: "Agents", single: true, badge: "Agent",
    mainLabel: "Agent definition",
    lands: ".claude/agents/",
    placeholder: "---\nname: code-reviewer\ndescription: Reviews a diff for bugs. Use after writing code.\ntools: Read, Grep, Glob\nmodel: sonnet\n---\nYou are a senior code reviewer. When invoked, ...",
  },
  command: {
    label: "Command", plural: "Commands", single: true, badge: "Command",
    mainLabel: "Command definition",
    lands: ".claude/commands/",
    placeholder: "---\ndescription: Summarize the current thread\nargument-hint: [topic]\n---\nSummarize the conversation above into 3 bullets ...",
  },
  output_style: {
    label: "Output style", plural: "Output styles", single: true, badge: "Output style",
    mainLabel: "Output style",
    lands: ".claude/output-styles/",
    placeholder: "---\nname: Terse\ndescription: Short, no preamble\n---\nRespond in <= 3 sentences. No preamble, no summary.",
  },
  claude_md: {
    label: "CLAUDE.md", plural: "CLAUDE.md", single: true, badge: "CLAUDE.md",
    mainLabel: "CLAUDE.md",
    lands: "your project root (or ~/.claude/)",
    placeholder: "# Project conventions\n- Use yarn, not npm\n- Tests: pytest -q\n- Branch per feature ...",
  },
};

// Order shown in the upload toggle + marketplace filter.
export const UPLOAD_KINDS = ["skill", "agent", "command", "output_style", "claude_md"];

export const kindOf = (k) => KINDS[k] || KINDS.skill;
export const kindBadge = (k) => KINDS[k]?.badge || null; // null for skill / unknown
